import { render, staticRenderFns } from "./AddressLookup.vue?vue&type=template&id=0fcd977a&scoped=true"
import script from "./AddressLookup.vue?vue&type=script&lang=js"
export * from "./AddressLookup.vue?vue&type=script&lang=js"
import style0 from "./AddressLookup.vue?vue&type=style&index=0&id=0fcd977a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd977a",
  null
  
)

export default component.exports